class FfSlider extends HTMLElement {
  constructor(){
    super();
    this.secondSlide = this.querySelectorAll('.second_box_slide');
    this.firstSlide = this.querySelectorAll(".first_box_slide")
    if (this.secondSlide) {
      this.createSlides()
    }
  }
createSlides(){
  if (screen.width<1000) {
    let contDiv = (this.secondSlide.length / 2);
    
    this.secondSlide.length == 2 && (this.secondSlide = [].slice.call(this.secondSlide, 1)); 
    
    this.secondSlide.forEach((slide, i) => {
      if(i+1 >= contDiv && i+1 < this.secondSlide.length || this.secondSlide.length == 1) {
        const clases = slide.parentNode.classList
        const newDiv = document.createElement("div");
        const clasesArray = clases.toString().split(" ")
        clasesArray.forEach(clase=>{
          newDiv.classList.add(clase)
        })
        const content = slide.outerHTML;
        newDiv.innerHTML = content 
        const currentDiv = slide.parentNode.parentNode;
        currentDiv.insertBefore(newDiv,slide.parentNode.nextSibling)
      }
      
    });

    this.firstSlide.forEach(firstBox=>{
      if (firstBox.nextElementSibling) {
        let saved = firstBox.nextElementSibling
        saved.parentNode.removeChild(saved)
      }
    })
    
  }
}
}
customElements.define('ff-slider', FfSlider);
